import { Redeem } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ClaimedCode } from '../ClaimedCode';
import { Promotion, PromotionStatus } from '../Promotion.model';
import { usePromotion } from '../PromotionContext';
import { PromotionReward } from '../PromotionReward';

interface Props {
  promotion: Promotion;
}

export function ClaimPromoCodeReward({ promotion }: Props): JSX.Element {
  const { t } = useTranslation();
  const { claim } = usePromotion();
  const history = useHistory();
  const [claimStatus, setClaimStatus] = useState<PromotionStatus>(null);

  useEffect(() => {
    setClaimStatus(promotion.userData?.status);
  }, [promotion]);

  const createPromocode = (): void => {
    claim(promotion.promotionData.promotionId);
  };

  return (
    <>
      {(!claimStatus || claimStatus === PromotionStatus.Claimable)
      && (
        <>
          <p className='claim-promotion-instructions'>
            {t('promotion.claim-reward.promocode.description')}
          </p>
          <div className='claim-promotion-summary'>
            {promotion.promotionData?.rewards?.map((reward) => (
              <PromotionReward key={reward.displayName} reward={reward} />
            ))}
          </div>
          <div className='p-4'>
            <button
              type='button'
              data-cy='claim-promocode-btn'
              className='btn btn-primary-game'
              onClick={createPromocode}
            >
              <>
                <Redeem />
                {t('button.claim-now')}
              </>
            </button>
          </div>
        </>
      )}
      {claimStatus === PromotionStatus.Claimed
        && (
          <>
            <div className='claim-promotion-summary'>
              {promotion.promotionData.rewards.map((reward) => (
                <PromotionReward key={reward.displayName} reward={reward} />
              ))}
            </div>
            <ClaimedCode userData={promotion.userData} />
            <div className='claim-promotion-instructions' data-cy='claim-promocode-instructions'>
              {t('promotion.claim-reward.promocode.instructions.description')}
              <ul>
                <li>
                  {t(
                    'promotion.claim-reward.promocode.instructions.step1',
                    { rewardGame: t(`games.${promotion.promotionData.relatedToGameId}`) },
                  )}
                </li>
                <li>{t('promotion.claim-reward.promocode.instructions.step2')}</li>
                <li>{t('promotion.claim-reward.promocode.instructions.step3')}</li>
                <li>{t('promotion.claim-reward.promocode.instructions.step4')}</li>
              </ul>
            </div>
            <button
              type='button'
              className='btn btn-primary-game btn-back-home'
              onClick={() => { history.push('/'); }}
              data-cy='claim-promocode-home-btn'
            >
              {t('button.return-home')}
            </button>
          </>
        )}
    </>
  );
}
